import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";


import LandingPage from "./pages/LandingPage/LandingPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import PricingPage from "./pages/PricingPage/PricingPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import OnboardingPage from "./pages/OnboardingPage/OnboardingPage";
import BlogListPage from "./pages/BlogListPage/BlogListPage";
import BlogContentPage from "./pages/BlogContentPage/BlogContentPage";
import InfluencerPage from "./pages/InfluencerPage/InfluencerPage";
import useAuthStore from "./stores/authStore";
import SummaryGenerator from "./pages/SummaryGenerator/SummaryGenerator";
import Success from "./pages/SuccessPage/SuccessPage";
import NewDashboardPage from "./pages/NewDashboardPage/NewDashboardPage";
import PostGenerator from "./components/PostGenerator/PostGenerator";
import HookGenerator from "./components/HookGenerator/HookGenerator";
import VideoDownloader from "./pages/VideoDownloader/VideoDownloader";
import OtherTools from "./components/OtherTools/OtherTools";
import LinkedInHeadlineGenerator from "./pages/HeadlineGenerator/LinkedInHeadlineGenerator";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";
import Contact from "./pages/ContactPage/Contact";
import TestUtilsPage from "./pages/TestUtilsPage/TestUtilsPage";
import MyPosts from "./components/MyPosts/MyPosts";
import MyProfile from "./pages/MyProfile/MyProfile";
import SubscriptionManagement from "./pages/SubscriptionManagement/SubscriptionManagement";
import { BlogProvider } from "./context/BlogContext";

const API_URL = process.env.REACT_APP_API_URL;

function App() {
  const { setUser, clearUser } = useAuthStore();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(`${API_URL}/auth/me`, {
          credentials: "include",
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
          console.log("🔑 Session restored:", userData);
        } else {
          clearUser();
          console.log("🚪 No active session.");
        }
      } catch (err) {
        console.error("❌ Error checking session:", err);
        clearUser();
      }
    };

    checkSession();
  }, [setUser, clearUser]);

  return (
    <BlogProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/blogs" element={<BlogListPage />} />
        
          <Route path="/blog/:slug" element={<BlogContentPage />} />
          <Route path="/influencer" element={<InfluencerPage />} />
          <Route
            path="/linkedin-video-downloader"
            element={<VideoDownloader />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
          <Route path="terms-and-conditions" element={<TermsAndConditions/>}/>
          <Route path="contact-us" element={<Contact/>}/>
           <Route path="/success" element={<Success />} />
          <Route path="/testutils" element={<TestUtilsPage/>}/>

          {/* Public Route */}
          <Route path="/linkedin-video-downloader" element={<VideoDownloader layout="public" />} />
          <Route path="/linkedin-summary-generator" element={<SummaryGenerator layout="public" />} />
          <Route path="/linkedin-headline-generator" element={<LinkedInHeadlineGenerator layout="public" />} />
          

          {/* Dashboard Routes with layout */}
          <Route path="/dashboard" element={<NewDashboardPage />}>
            <Route index element={<PostGenerator />} />
            <Route path="generate-linkedin-hooks" element={<HookGenerator />} />
          <Route path="my-posts" element={<MyPosts/>}/>
            <Route path="free-tools" element={<OtherTools />} />
            <Route path="free-tools/linkedin-video-downloader" element={<VideoDownloader layout="dashboard" />} />
            <Route path="free-tools/linkedin-summary-generator" element={<SummaryGenerator layout="dashboard" />} />
            <Route path="free-tools/linkedin-headline-generator" element={<LinkedInHeadlineGenerator layout="dashboard" />} />
          <Route path="profile" element={<MyProfile/>} />
          <Route path="subscription" element={<SubscriptionManagement />} />
          </Route>
        </Routes>
      </Router>
    </BlogProvider>
  );
}

export default App;
